import IconInfoFill from 'assets/Icons/Notice/Icon_Info_fill';
import styled from 'styled-components';
import { Accent } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body4SemiBold, Body5Medium } from 'styles/Global/typography';

export default function ResultNotiMsg() {
    return (
        <InspectionGuideContainer>
            <InspectionTitleWrapper>
                <IconWrapper>
                    <IconInfoFill />
                </IconWrapper>
                결과지 안내
            </InspectionTitleWrapper>
            <DescContainer>
                <DescWrapper>
                    <Body5Medium>검사 설정을 위해 ‘생년월일'과 ‘만 나이'는 입력한 정보와 다르게 표시될 수 있으며, 이는 결과에 문제가 되지 않으므로 참고 바랍니다.</Body5Medium>
                </DescWrapper>
            </DescContainer>
        </InspectionGuideContainer>
    );
}

const InspectionGuideContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
    border-radius: ${Radius.radius_8};
    padding: 12px 16px 14px 12px;
    background-color: ${Accent['color-accent-yellow-opacity-8']};
`;

const InspectionTitleWrapper = styled(Body4SemiBold)`
    display: flex;
    height: 24px;
    align-items: center;
    gap: 4px;
`;

const DescContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 18px;
    gap: 4px;
`;

const DescWrapper = styled.div`
    display: flex;
    gap: 4px;
    padding-left: 4px;
    align-items: start;
`;

const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 3px;
`;
